module.exports = __webpack_public_path__ + "static/Bosslr-4623281a750d7f91c4a68d398e0eb39d.png";